"use client";
import React, { Suspense, useState } from "react";
import CareerCard from "./career-card";
import ApplyCareer from "./apply-career";
import { Skeleton } from "./ui/skeleton";

type Props = {};

const CareerModal = ({ careers }: any) => {
  return (
    <Suspense
      fallback={
        <div>
          <Skeleton className="h-20" />
        </div>
      }
    >
      <section className="relative py-12 md:py-16">
        <div className="container mx-auto max-w-4xl px-6">
          {/* Section header */}
          <div className="mb-8 text-center" data-aos="fade-up" data-aos-duration="600">
            <h2 className="text-2xl md:text-3xl font-bold text-slate-900">
              Open Positions
            </h2>
            <p className="mt-2 text-sm text-slate-500">
              {careers.length > 0
                ? `We have ${careers.length} role${careers.length > 1 ? "s" : ""} open right now.`
                : "No open positions at the moment — check back soon!"}
            </p>
            <div className="mx-auto mt-4 h-1 w-12 rounded-full bg-gradient-to-r from-indigo-500 to-violet-500" />
          </div>

          {/* Cards */}
          <div className="flex flex-col gap-4">
            {careers.map((career: any, id: any) => (
              <CareerCard key={id} career={career} />
            ))}
          </div>
        </div>
      </section>
    </Suspense>
  );
};

export default CareerModal;
